import { getFullUrl } from 'hubspot-url-utils';
import { SNIPPETS_AMOUNT_LIMIT } from '../../constants/comments';
import baseHttpClient from '../../utils/apiClient';
import { sortSnippetResults } from '../../utils/comments';
export const fetchRenderedContent = ({
  id,
  cb,
  supplementalObjects = {}
}) => baseHttpClient.post(`${getFullUrl('app-api')}/snippets/v1/render`, {
  data: {
    contactId: null,
    snippetId: id,
    supplementalObjects
  }
}).finally(() => {
  if (typeof cb === 'function') cb();
});
export const fetchUnrenderedContent = ({
  id
}) => baseHttpClient.get(`${getFullUrl('app-api')}/snippets/v1/snippets/${id}`);
export const searchSnippets = ({
  count = SNIPPETS_AMOUNT_LIMIT,
  offset = 0,
  query = ''
}) => baseHttpClient.post(`${getFullUrl('app-api')}/salescontentsearch/v2/search`, {
  data: {
    contentTypesToHydrate: ['SNIPPET'],
    filters: [{
      field: 'content_type',
      values: ['SNIPPET']
    }],
    limit: count,
    offset,
    query
  }
}).then(response => sortSnippetResults({
  response,
  query
}));